import m from "../../geodata/es2015/ukHigh";
window.am4geodata_ukHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/ukHigh.js
// module id = null
// module chunks = 